import { createAction } from 'typesafe-actions';

export const setPage = createAction(
  'IMPORTED_ORGANIZATION_PAGE_SET',
  (action) => (pageIndex: number) => action(pageIndex)
);

export const setPageSize = createAction(
  'IMPORTED_ORGANIZATION_PAGE_SIZE_SET',
  (action) => (pageSize: number) => action(pageSize)
);
